import { render, staticRenderFns } from "./g-listpagesize.vue?vue&type=template&id=7ae6b68c&scoped=true"
import script from "./g-listpagesize.vue?vue&type=script&lang=js"
export * from "./g-listpagesize.vue?vue&type=script&lang=js"
import style0 from "./g-listpagesize.vue?vue&type=style&index=0&id=7ae6b68c&prod&lang=less&scoped=true"
import style1 from "./g-listpagesize.vue?vue&type=style&index=1&id=7ae6b68c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae6b68c",
  null
  
)

export default component.exports